<template>
    <div class="mtg-agents-block__body">
        <div class="mtg-agents-block__head g-text__p _gray g_semibold">Документы</div>
        <div class="mtg-agents-block__docs">
            <a
                v-for="doc in docList"
                :key="`doc-${doc.id}`"
                class="mtg-agents-block__doc u-link__download"
                :href="doc.props.file.src"
                target="_blank"
            >
                <span class="u-link__download-text g_medium">{{ doc.name }}</span>
            </a>
            <div v-if="allPages > curPage" class="mtg-agents-block__more g_center">
                <a @click.prevent="getMoreDocs" href="#" class="mtg-table__btn u-link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_11_15424)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3.06674C8.16117 3.06674 6.39765 3.79721 5.09739 5.09746C3.79714 6.39772 3.06667 8.16124 3.06667 10.0001H2C1.99979 8.39196 2.48423 6.82111 3.39011 5.49243C4.296 4.16375 5.58129 3.13892 7.07833 2.55162C8.57536 1.96432 10.2146 1.84182 11.7823 2.2001C13.35 2.55837 14.7734 3.38079 15.8667 4.56007V2.00007H16.9333V6.26674H12.6667V5.20007H15.0027C14.3564 4.52467 13.5798 3.98739 12.72 3.6207C11.8601 3.25402 10.9348 3.06557 10 3.06674V3.06674ZM10 16.9334C10.9105 16.9334 11.8121 16.7541 12.6533 16.4056C13.4945 16.0572 14.2588 15.5465 14.9026 14.9027C15.5464 14.2589 16.0571 13.4945 16.4056 12.6533C16.754 11.8122 16.9333 10.9106 16.9333 10.0001H18C18 11.6081 17.5154 13.1788 16.6094 14.5073C15.7035 15.8358 14.4182 16.8605 12.9212 17.4477C11.4242 18.0348 9.785 18.1572 8.21741 17.7989C6.64981 17.4406 5.22658 16.6182 4.13333 15.439V18.0001H3.06667V13.7334H7.33333V14.8001H4.99733C5.64361 15.4755 6.42016 16.0128 7.28003 16.3794C8.1399 16.7461 9.06521 16.9346 10 16.9334V16.9334Z" fill="currentColor"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_11_15424">
                                <rect width="16" height="16" fill="currentColor" transform="translate(2 2)"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                    <span class="g-text__p _semibold">Показать ещё</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'MortAgentsDocsShowMore',
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        },
        category: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            curPage: 1,
            allPages: 2,
            docList: []
        };
    },
    methods: {
        getMoreDocs() {
            const apiUrl = `/api/v2/content/ia/${this.category}/internal-documents/`;
            this.curPage = this.curPage + 1;

            axios.get(
                apiUrl,
                {
                    params: {
                        page: this.curPage,
                        'page-size': 5
                    }
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).then(({ data }) => {
                this.allPages = data.nav.NavPageCount;
                data.data.forEach((item) => {
                    this.docList.push(item);
                });
            }).catch((error) => {
                console.error(error);
            });
        }
    },
    created() {
        this.docList = this.data.data;
    }
};
</script>
